<script setup lang="ts">
import {computed} from "vue";
import {ChevronLeft, ChevronRight} from "@lucide/vue";

const {page, lastPage, total, noun, plural} = defineProps<{
    page: number;
    lastPage: number;
    total: number;
    /** Singular noun of what is counted, "absence" giving "1 absence". */
    noun: string;
    /** Plural form, when appending an "s" would not do — "absences archivées". */
    plural?: string;
}>();

const counted = computed<string>(() => total > 1 ? plural ?? `${noun}s` : noun);

defineEmits<{
    (event: 'go', page: number): void;
}>();
</script>

<template>
  <!-- The count stands on its own: a single page still says how much it holds. -->
  <div v-if="total" class="mt-2.5 flex items-center justify-end gap-2">
    <span class="mr-auto text-[10.5px] text-gray-400">
      {{ total }} {{ counted }}
    </span>
    <template v-if="lastPage > 1">
      <button
        type="button"
        title="Page précédente"
        class="flex size-7 items-center justify-center rounded-lg border border-solid border-gray-200 bg-white text-gray-600 hover:border-gray-300 disabled:cursor-not-allowed disabled:opacity-40"
        :disabled="page <= 1"
        @click="$emit('go', page - 1)"
      >
        <ChevronLeft class="size-3.5" />
      </button>
      <span class="text-[10.5px] font-semibold text-gray-600">
        Page {{ page }} / {{ lastPage }}
      </span>
      <button
        type="button"
        title="Page suivante"
        class="flex size-7 items-center justify-center rounded-lg border border-solid border-gray-200 bg-white text-gray-600 hover:border-gray-300 disabled:cursor-not-allowed disabled:opacity-40"
        :disabled="page >= lastPage"
        @click="$emit('go', page + 1)"
      >
        <ChevronRight class="size-3.5" />
      </button>
    </template>
  </div>
</template>
